import { compose } from 'redux'
import { mapProps, withProps } from 'recompose'
import { getFilteredTireSpecifications, filterVisibleSpecs } from './helpers'
import withType from 'components/common/hoc/withType'
import BOTTireLineSpecification from './BOTTireLineSpecification'

const withFilteredTireSpecifications = mapProps(({ tireSpecifications = []}) => ({
  tireSpecifications: getFilteredTireSpecifications(tireSpecifications)
}))

const withFilteredVisibleSpecs = withProps(
  ({ tireSpecifications = []}) => ({
    filteredSpecs: filterVisibleSpecs(tireSpecifications)
  })
)

export default compose(
  withType({ type: 'BOTTireLineSpecification' }),
  withFilteredTireSpecifications,
  withFilteredVisibleSpecs
)(BOTTireLineSpecification)
